import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-1 min-w-max mb-4 field" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4 mb-4"
}

import { onMounted, onUnmounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import { useClinicianDisciplineStore } from '@/store';
import CheckboxForm from '@/components/Forms/CheckboxForm';
import { PERMISSIONS } from '@/enum';
import { can } from '@/composables';

interface PropsInterface {
  clinicianId: number | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClinicianDisciplines',
  props: {
    clinicianId: {}
  },
  setup(__props: any) {

const props = __props;
const clinicianDisciplineStore = useClinicianDisciplineStore();
const { disciplines, loading } = storeToRefs(clinicianDisciplineStore);
const dirty = ref(false);
const toast = useToast();

const onSave = async () => {
  if (can([PERMISSIONS.CLINICIAN_SYNC_DISCIPLINES])) {
    const result = await clinicianDisciplineStore.saveDisciplines(props.clinicianId as number);

    if (result === 200) {
      toast.add({
        severity: 'success',
        summary: 'Saved',
        detail: 'Disciplines has been saved',
        life: 3000,
      });
      dirty.value = false;
    }
  }
};

const onUpdate = (id: string, checked: boolean) => {
  if (can([PERMISSIONS.CLINICIAN_SYNC_DISCIPLINES])) {
    if (!dirty.value) {
      dirty.value = true;
    }
    clinicianDisciplineStore.updateDisciplineForClinician({ id, checked });
  }
};

const onCancel = () => {
  dirty.value = false;
  if (can([PERMISSIONS.CLINICIAN_DISCIPLINES_INDEX]))
    clinicianDisciplineStore.getDisciplines(props.clinicianId as number);
};

onMounted(() => {
  if (
    can([PERMISSIONS.CLINICIAN_DISCIPLINES_INDEX]) &&
    (!clinicianDisciplineStore.disciplineIDs || clinicianDisciplineStore.disciplineIDs.length === 0)
  ) {
    clinicianDisciplineStore.getDisciplines(props.clinicianId as number);
  }
});

onUnmounted(() => {
  clinicianDisciplineStore.$reset();
});

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CheckboxForm), {
      title: "Disciplines",
      items: _unref(disciplines),
      "update-item": onUpdate,
      save: onSave,
      loading: _unref(loading),
      cancel: onCancel,
      dirty: dirty.value,
      "class-name": "checkbox-form"
    }, {
      default: _withCtx(() => [
        (_unref(clinicianDisciplineStore).disciplineIDs?.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("label", { for: "is_primary" }, "Primary Discipline", -1)),
              _createVNode(_component_Dropdown, {
                id: "is_primary",
                modelValue: _unref(clinicianDisciplineStore).primaryId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(clinicianDisciplineStore).primaryId) = $event)),
                options: _unref(clinicianDisciplineStore).getDisciplinesForDropdown(),
                class: "w-full mt-2",
                "option-label": "name",
                "option-value": "id",
                placeholder: "Select a primary discipline",
                "show-clear": true,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (onUpdate(_ctx.id, false)))
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["items", "loading", "dirty"])
  ]))
}
}

})